import React from 'react';
import Reflux from 'reflux';
import moment from 'moment';
import { Alert } from 'bootstrap';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import { hasTeleprompterFullAccess } from 'shared/lib/permission';
import FullScreenCuesheetActions from 'flux/actions/cuesheet.fullscreen/FullScreenCuesheetActions';

export default React.createClass({
  displayName: 'PrompterAlertBar',

  mixins: [Reflux.ListenerMixin],

  getInitialState() {
    return {
      countdown: this._getCountdownDuration(),
    };
  },

  componentDidMount() {
    this._startCountdown();
    this.listenTo(
      FullScreenCuesheetActions.resetPrompterTrialCountdown,
      '_onResetPrompterTrialCountdown',
    );
  },

  _getCountdownDuration() {
    return moment.duration(2, 'minutes');
  },

  _onResetPrompterTrialCountdown() {
    this.setState({ countdown: this._getCountdownDuration() });
    this._startCountdown();
  },

  _tick() {
    const { countdown } = this.state;

    const decrementedCountdown = countdown.subtract(1, 'seconds');

    this.setState({ countdown: decrementedCountdown });

    if (decrementedCountdown.asSeconds() === 0) {
      if (this.interval) clearInterval(this.interval);
      FullScreenCuesheetActions.setForceOnboardingWelcome(true);
    }
  },

  _startCountdown() {
    const { permissions } = this.props;

    if (this.interval) clearInterval(this.interval);

    if (!hasTeleprompterFullAccess(permissions)) {
      this.interval = setInterval(this._tick, 1000);
    }
  },

  render() {
    const { permissions } = this.props;
    const { countdown } = this.state;

    if (hasTeleprompterFullAccess(permissions)) return null;

    const minutes = countdown.minutes();
    const seconds = countdown.seconds();
    const leadingZero = seconds < 10 ? 0 : '';

    return (
      <div className="featured-editor-alert-bar-wrapper display-alert">
        <Alert className="featured-editor-alert-bar">
          <Icon name="exclamation-triangle" />
          <span className="featured-editor-alert-bar-warning">Heads Up!</span>
          <span>
            {`This is a limited preview of Prompter. ${minutes}:${leadingZero}${seconds} left`}
          </span>
          <span>
            <a href="https://shoflo.tv/teleprompter-software/" target="_blank">
              Learn more
            </a>
          </span>
        </Alert>
      </div>
    );
  },
});
